"use client";
import React from "react";
import { Link } from "react-router-dom";
import {
  FaUserTie,
  FaCalculator,
  FaBuilding,
  FaFileInvoice,
  FaShieldAlt,
  FaChartLine,
  FaArrowRight,
  FaFileAlt,
  FaFileInvoiceDollar,
  FaSearch
} from "react-icons/fa";

function TaxServices() {
  const leftCards = [
    {
      title: "Individual Tax Services",
      desc: "From tax planning to filing, we assist individuals in optimizing their tax positions, ensuring compliance with the latest tax laws.",
      icon: <FaUserTie />
    },
    {
      title: "Tax Consulting",
      desc: "Leverage our expertise for strategic tax advice, specialized consulting, and navigating complex tax issues with confidence.",
      icon: <FaCalculator />
    }
  ];

  const rightCards = [
    {
      title: "Business Tax Services",
      desc: "Our comprehensive business tax solutions cover everything from strategic tax planning to compliance, helping businesses minimize tax liabilities and enhance profitability.",
      icon: <FaBuilding />
    },
    {
      title: "Tax Representation",
      desc: "Cases where representation is required before various authorities including but not limited to Income Tax Department and GST Trademark, RERA, FSSAI, DGFT our experienced team stands by your side, providing steadfast representation to protect your interests.",
      icon: <FaSearch />
    }
  ];

  return (
    <section className="tax-services-v2">
      {/* Background Waves */}
      <div className="bg-wave-tl"></div>
      <div className="bg-wave-br"></div>

      {/* Floating Elements (Left) */}
      <div className="floating-3d-left d-none d-xl-flex">
        <div className="f3d-doc">
          <FaFileAlt className="doc-icon" />
          <span>TAX</span>
        </div>
        <div className="f3d-percent">%</div>
      </div>

      {/* Floating Elements (Right) */}
      <div className="floating-3d-right d-none d-xl-flex">
        <div className="f3d-chart">
          <FaChartLine />
        </div>
        <div className="f3d-percent-blue">%</div>
      </div>

      <div className="container position-relative z-3">

        {/* HEADER SECTION */}
        <div className="header-box text-center mb-5">
          <div className="pill-badge d-inline-flex align-items-center mb-3">
            <div className="badge-icon">
              <FaFileInvoiceDollar />
            </div>
            <span>Our Tax Services</span>
          </div>
          <h2 className="main-title">
            <span className="text-dark-blue">Our</span> <span className="text-bright-blue">Tax Services</span>
          </h2>
          <p className="sub-desc">
            Smart, reliable and hassle-free tax solutions for individuals, businesses and organizations.
          </p>
          <div className="gradient-dash"></div>
        </div>

        {/* 3-COLUMN GRID */}
        <div className="row g-4 justify-content-center align-items-stretch">

          {/* LEFT COLUMN */}
          <div className="col-lg-4 d-flex flex-column gap-4">
            {leftCards.map((card, index) => (
              <div className="side-card" key={index}>
                <div className="wave-tr"></div>
                <div className="wave-bl"></div>
                <div className="card-content-wrap">
                  <div className="card-icon-wrap">
                    {card.icon}
                  </div>
                  <div className="card-text-wrap">
                    <h3>{card.title}</h3>
                    <p>{card.desc}</p>
                  </div>
                </div>
                <Link to="/contact" className="arrow-btn">
                  <FaArrowRight />
                </Link>
              </div>
            ))}
          </div>

          {/* CENTER COLUMN (Accounting Services) */}
          <div className="col-lg-4">
            <div className="center-hero-card">

              {/* Graphic Area */}
              <div className="center-graphic-container">
                <div className="bg-dots-grid"></div>

                {/* Floating small icons */}
                <div className="cg-float-icon fi-left"><FaShieldAlt /></div>
                <div className="cg-float-icon fi-top"><FaFileAlt /></div>
                <div className="cg-float-icon fi-right"><FaFileInvoice /></div>

                {/* Main center 3D elements */}
                <div className="main-graphic">
                  <div className="mg-calc"><FaCalculator /></div>
                  <div className="mg-tax-doc">TAX <div className="lines"></div></div>
                  <div className="mg-percent-circle">%</div>
                  <div className="mg-chart"><FaChartLine /></div>
                </div>
              </div>

              <h3 className="hero-title">
                Accounting <span className="text-cyan">Services</span>
              </h3>

              <p className="hero-desc">
                Our suite of services is designed to cater to businesses of all sizes and industries. Whether you're a startup, a small business, or a large corporation, we offer a range of Accounting services tailored to meet your specific needs. From bookkeeping and payroll processing to tax planning and financial analysis, we are your one-stop solution for all.
              </p>

              <Link to="/contact" className="btn-hero-learn">
                Learn More <FaArrowRight className="ms-2" />
              </Link>

              <div className="hero-bottom-wave"></div>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="col-lg-4 d-flex flex-column gap-4">
            {rightCards.map((card, index) => (
              <div className="side-card" key={index}>
                <div className="wave-tr"></div>
                <div className="wave-bl"></div>
                <div className="card-content-wrap">
                  <div className="card-icon-wrap">
                    {card.icon}
                  </div>
                  <div className="card-text-wrap">
                    <h3>{card.title}</h3>
                    <p>{card.desc}</p>
                  </div>
                </div>
                <Link to="/contact" className="arrow-btn">
                  <FaArrowRight />
                </Link>
              </div>
            ))}
          </div>

        </div>
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        .tax-services-v2 {
          background: #f0f7ff;
          padding: 80px 0 100px 0;
          position: relative;
          overflow: hidden;
          font-family: 'Inter', sans-serif;
        }

        /* BACKGROUND WAVES */
        .bg-wave-tl {
          position: absolute;
          top: -10%;
          left: -5%;
          width: 45%;
          height: 40%;
          background: linear-gradient(135deg, #165986 0%, #0ea5e9 100%);
          border-radius: 0 0 100% 0;
          opacity: 0.85;
          z-index: 1;
        }
        .bg-wave-tl::after {
          content: '';
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          background: rgba(255,255,255,0.1);
          border-radius: 0 0 100% 0;
          transform: scale(1.05) translate(10px, 10px);
          z-index: -1;
        }
        
        .bg-wave-br {
          position: absolute;
          bottom: -10%;
          right: -5%;
          width: 50%;
          height: 35%;
          background: linear-gradient(315deg, #1e3a8a 0%, #165986 100%);
          border-radius: 100% 0 0 0;
          opacity: 0.9;
          z-index: 1;
        }
        .bg-wave-br::after {
          content: '';
          position: absolute;
          bottom: 0; right: 0; width: 100%; height: 100%;
          background: linear-gradient(315deg, transparent 50%, rgba(14, 165, 233, 0.3) 100%);
          border-radius: 100% 0 0 0;
          transform: scale(1.1) translate(-10px, -10px);
          z-index: -1;
        }

        /* FLOATING 3D ELEMENTS */
        .floating-3d-left {
          position: absolute;
          top: 15%;
          left: 5%;
          z-index: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;
          animation: floatUpDown 6s ease-in-out infinite;
        }
        .f3d-doc {
          background: rgba(255,255,255,0.9);
          border: 1px solid #dbeafe;
          padding: 15px;
          border-radius: 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #165986;
          font-weight: 800;
          font-size: 16px;
          box-shadow: 0 15px 30px rgba(29, 78, 216, 0.15);
          transform: perspective(400px) rotateY(15deg);
        }
        .f3d-doc .doc-icon { font-size: 24px; margin-bottom: 5px; }
        .f3d-percent {
          width: 50px; height: 50px;
          background: #38bdf8;
          color: #fff;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 24px; font-weight: 800;
          box-shadow: 0 10px 20px rgba(56, 189, 248, 0.4);
          transform: perspective(400px) rotateY(-15deg);
        }

        .floating-3d-right {
          position: absolute;
          top: 15%;
          right: 5%;
          z-index: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;
          animation: floatUpDown 7s ease-in-out infinite reverse;
        }
        .f3d-chart {
          background: rgba(255,255,255,0.9);
          border: 1px solid #dbeafe;
          padding: 20px;
          border-radius: 15px;
          color: #165986;
          font-size: 40px;
          box-shadow: 0 15px 30px rgba(29, 78, 216, 0.15);
          transform: perspective(400px) rotateY(-15deg);
        }
        .f3d-percent-blue {
          width: 50px; height: 50px;
          background: #165986;
          color: #fff;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 24px; font-weight: 800;
          box-shadow: 0 10px 20px rgba(29, 78, 216, 0.4);
          transform: perspective(400px) rotateY(15deg);
        }

        @keyframes floatUpDown {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }

        /* HEADER */
        .pill-badge {
          background: #165986;
          color: #fff;
          padding: 5px 18px 5px 5px;
          border-radius: 30px;
          font-weight: 700;
          font-size: 14px;
          box-shadow: 0 5px 15px rgba(29, 78, 216, 0.3);
        }
        .badge-icon {
          background: #fff;
          color: #165986;
          width: 26px; height: 26px;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          margin-right: 10px;
          font-size: 14px;
        }
        .main-title {
          font-size: 56px;
          font-weight: 900;
          margin-bottom: 15px;
          letter-spacing: -1px;
        }
        .text-dark-blue { color: #0f172a; }
        .text-bright-blue { color: #3e5c87ff; }
        .sub-desc {
          color: #475569;
          font-size: 18px;
          font-weight: 500;
          max-width: 700px;
          margin: 0 auto 20px auto;
        }
        .gradient-dash {
          width: 60px; height: 5px;
          background: linear-gradient(90deg, #165986, #38bdf8);
          border-radius: 5px;
          margin: 0 auto;
        }

        /* SIDE CARDS (White) */
        .side-card {
          background: #ffffff;
          border-radius: 20px;
          padding: 30px 25px 40px 25px;
          position: relative;
          overflow: hidden;
          box-shadow: 0 15px 35px rgba(29, 78, 216, 0.05);
          border: 1.5px solid rgba(255,255,255,1);
          height: 100%;
          transition: all 0.3s ease;
        }
        .side-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 45px rgba(29, 78, 216, 0.12);
        }
        
        .wave-tr {
          position: absolute;
          top: 0; right: 0;
          width: 60px; height: 60px;
          background: linear-gradient(225deg, #0ea5e9, #165986);
          border-bottom-left-radius: 100%;
          opacity: 0.9;
        }
        .wave-bl {
          position: absolute;
          bottom: 0; left: 0;
          width: 60px; height: 60px;
          background: linear-gradient(45deg, #0ea5e9, #165986);
          border-top-right-radius: 100%;
          opacity: 0.9;
        }

        .card-content-wrap {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          position: relative;
          z-index: 2;
          height: 100%;
        }

        .card-icon-wrap {
          width: 65px; height: 65px;
          flex-shrink: 0;
          border-radius: 50%;
          background: #eff6ff;
          border: 2px solid #bfdbfe;
          display: flex; align-items: center; justify-content: center;
          font-size: 26px; color: #165986;
          box-shadow: 0 0 20px rgba(59, 130, 246, 0.15);
        }

        .card-text-wrap h3 {
          font-size: 20px;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 12px;
          margin-top: 5px;
        }
        .card-text-wrap p {
          color: #64748b;
          font-size: 13.5px;
          line-height: 1.6;
          margin: 0;
        }

        .arrow-btn {
          position: absolute;
          bottom: 15px; right: 15px;
          width: 40px; height: 40px;
          background: #165986;
          color: #fff;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          text-decoration: none;
          font-size: 16px;
          transition: background 0.3s ease, transform 0.3s ease;
          z-index: 3;
        }
        .arrow-btn:hover {
          background: #1e3a8a;
          color: #fff;
          transform: scale(1.1);
        }

        /* CENTER HERO CARD (Dark Blue) */
        .center-hero-card {
          background: linear-gradient(160deg, #020617 0%, #1e3a8a 50%, #165986 100%);
          border-radius: 24px;
          padding: 40px 30px;
          position: relative;
          overflow: hidden;
          border: 2px solid #38bdf8;
          box-shadow: 0 0 40px rgba(56, 189, 248, 0.4), inset 0 0 20px rgba(56, 189, 248, 0.3);
          text-align: center;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .center-graphic-container {
          position: relative;
          height: 180px;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .bg-dots-grid {
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          background-image: radial-gradient(rgba(255,255,255,0.1) 1px, transparent 1px);
          background-size: 10px 10px;
          opacity: 0.5;
        }

        .cg-float-icon {
          position: absolute;
          width: 35px; height: 35px;
          background: rgba(255,255,255,0.1);
          border: 1px solid rgba(56,189,248,0.5);
          color: #38bdf8;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 14px;
          animation: floatUpDown 4s ease-in-out infinite;
        }
        .fi-left { top: 30%; left: 15%; animation-delay: 0s; }
        .fi-top { top: 10%; left: 50%; transform: translateX(-50%); animation-delay: 1s; }
        .fi-right { top: 30%; right: 15%; animation-delay: 2s; }

        .main-graphic {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          gap: 15px;
        }
        .mg-calc {
          background: rgba(255,255,255,0.9);
          color: #165986;
          padding: 15px;
          border-radius: 12px;
          font-size: 30px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.3);
          transform: perspective(400px) rotateY(15deg);
        }
        .mg-tax-doc {
          background: rgba(255,255,255,0.95);
          color: #165986;
          padding: 15px 20px;
          border-radius: 8px;
          font-size: 24px;
          font-weight: 900;
          box-shadow: 0 15px 30px rgba(0,0,0,0.4);
          transform: translateY(-10px);
          display: flex; flex-direction: column; align-items: center;
        }
        .mg-tax-doc .lines {
          width: 30px; height: 2px; background: #cbd5e1; margin-top: 8px;
          position: relative;
        }
        .mg-tax-doc .lines::after {
          content: ''; position: absolute; top: 6px; left: 0; width: 20px; height: 2px; background: #cbd5e1;
        }
        .mg-percent-circle {
          width: 45px; height: 45px;
          background: #38bdf8;
          color: #fff;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          font-size: 20px; font-weight: 800;
          box-shadow: 0 10px 20px rgba(56, 189, 248, 0.4);
          transform: translateY(-30px);
          position: absolute;
          right: 30%;
        }
        .mg-chart {
          background: rgba(255,255,255,0.9);
          color: #165986;
          padding: 12px;
          border-radius: 12px;
          font-size: 26px;
          box-shadow: 0 10px 20px rgba(0,0,0,0.3);
          transform: perspective(400px) rotateY(-15deg);
        }

        .hero-title {
          color: #fff;
          font-size: 28px;
          font-weight: 800;
          margin-bottom: 15px;
          position: relative; z-index: 2;
        }
        .text-cyan {
          color: #38bdf8;
        }
        .hero-desc {
          color: #e2e8f0;
          font-size: 13.5px;
          line-height: 1.7;
          margin-bottom: 30px;
          position: relative; z-index: 2;
        }

        .btn-hero-learn {
          background: transparent;
          color: #fff;
          border: 1px solid #38bdf8;
          padding: 10px 25px;
          border-radius: 30px;
          font-size: 14px;
          font-weight: 700;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin: auto auto 0 auto;
          position: relative; z-index: 2;
          box-shadow: 0 0 15px rgba(56, 189, 248, 0.3), inset 0 0 15px rgba(56, 189, 248, 0.3);
          transition: all 0.3s ease;
        }
        .btn-hero-learn:hover {
          background: #38bdf8;
          color: #0f172a;
          box-shadow: 0 0 25px rgba(56, 189, 248, 0.6);
        }

        .hero-bottom-wave {
          position: absolute;
          bottom: -20px; left: 0;
          width: 100%; height: 80px;
          background: linear-gradient(180deg, transparent, rgba(56, 189, 248, 0.4));
          border-radius: 50% 50% 0 0;
          filter: blur(5px);
          z-index: 1;
        }

        /* RESPONSIVE */
        @media (max-width: 1200px) {
          .card-content-wrap { flex-direction: column; align-items: center; text-align: center; }
          .arrow-btn { position: relative; bottom: 0; right: 0; margin-top: 15px; }
          .side-card { display: flex; flex-direction: column; align-items: center; }
        }

        @media (max-width: 991px) {
          .tax-services-v2 { padding: 60px 0; }
          .main-title { font-size: 42px; }
          .bg-wave-tl { width: 50%; height: 30%; }
        }

        @media (max-width: 768px) {
          .tax-services-v2 { padding: 50px 0 60px 0; }
          .main-title { font-size: 32px; }
          .sub-desc { font-size: 15px; padding: 0 10px; }
          .side-card { padding: 30px 20px; }
          .card-icon-wrap { width: 55px; height: 55px; font-size: 22px; }
          .card-text-wrap h3 { font-size: 18px; }
          .card-text-wrap p { font-size: 13px; }
          
          .center-hero-card { padding: 30px 20px; border-radius: 20px; }
          .center-graphic-container { height: 140px; transform: scale(0.85); }
          .hero-title { font-size: 24px; }
          .hero-desc { font-size: 13px; }
        }
        `
      }} />
    </section>
  );
}

export default TaxServices;